import { render, staticRenderFns } from "./PesquisaMensagem.vue?vue&type=template&id=446617c8"
import script from "./PesquisaMensagem.vue?vue&type=script&lang=js"
export * from "./PesquisaMensagem.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMensagem.vue?vue&type=style&index=0&id=446617c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports